import { db } from '@/config'

export default {
  state: {
    tags: null
  },
  mutations: {
    setTags (state, payload) {
      if (payload) {
        console.log(payload)
        const cache = payload.map(tag => {
          const programs = (tag.programs || []).map(program => {
            const {
              created,
              description,
              direction,
              duration,
              genre,
              id,
              image,
              imageH,
              media,
              rating_eu,
              slug,
              starring,
              title,
              order
            } = program
            return {
              created,
              description,
              direction,
              duration,
              genre,
              id,
              image,
              imageH,
              media,
              rating_eu,
              slug,
              starring,
              title,
              order
            }
          })
          return {...tag, programs}
        })
        localStorage.setItem('tags', JSON.stringify(cache))
      }
      state.tags = payload
    }
  },
  actions: {
    getTags ({ commit }) {
      const now = new Date().getTime()

      commit('setTags', JSON.parse(localStorage.getItem('tags')) || [])

      return db.collection('tags_programs').orderBy('order').onSnapshot(async querySnapshot => {
        const tags = [];
        querySnapshot.docs.map(doc => {
          const data = doc.data()
          if (data.date_start <= now && now <= data.date_end) {
            data.tag.order = data.order
            data.tag.type = data.type
            data.tag.programs = (data.tag.programs || []).filter((program, i) => program.date_start <= now && now <= program.date_end)
            data.tag.programs.sort((a, b) => (Number(a.order) - Number(b.order)))

            if (data.web !== false)
              tags.push(data.tag);
          }
        })
        console.log({tags})

        const aux = tags.sort((a, b) => a.order > b.order ? 1 : -1)
        commit('setTags', aux)
        return aux
      })
    },
    getTagsOnce ({ commit }) {
      const now = new Date().getTime()

      commit('setTags', JSON.parse(localStorage.getItem('tags')) || [])

      return db.collection('tags_programs').orderBy('order').get().then(async querySnapshot => {
        const tags = [];
        querySnapshot.docs.map(doc => {
          const data = doc.data()
          if (data.date_start <= now && now <= data.date_end) {
            data.tag.order = data.order
            tags.push(data.tag);
            (data.tag.programs || []).map((program, i) => {
              if (program.date_start <= now && now <= program.date_end) {}
              else {
                data.tag.programs.splice(i, 1)
              }
            })
          }
        })

        const aux = tags.sort((a, b) => a.order > b.order ? 1 : -1)
        commit('setTags', aux)
        return aux
      })
    }
  },
  getters: {
    tags: (state) => (state.tags || []).filter(Boolean).map(tag => {
      //tag.programs = (tag.programs || []).sort((a, b) => (b.order || 999) - (a.order || 999))
      return tag
    })
  }
}
